// Pure helpers for the Testing page reconstruction card (T-211); kept out of the component so node --test can import them.
export const HEALTH_STYLE = {
  running: { label: 'RUNNING', cls: 'bg-emerald-900/40 text-emerald-300 border-emerald-700/40' },
  stalled: { label: 'STALLED', cls: 'bg-red-900/40 text-red-300 border-red-700/40' },
  complete: { label: 'COMPLETE', cls: 'bg-cyan-900/40 text-cyan-300 border-cyan-700/40' },
  stopped: { label: 'STOPPED', cls: 'bg-amber-900/40 text-amber-300 border-amber-700/40' },
}

export const fmtPct = (v, d = 1) => (v == null || Number.isNaN(Number(v)) ? 'n/a' : `${Number(v).toFixed(d)} %`)
export const fmtTs = (v) => (v ? `${String(v).slice(0, 16).replace('T', ' ')} UTC` : 'n/a')
export const anyRunning = (resp) => !!resp?.runs?.some((r) => r.health === 'running')
export const progressPct = (run) => (run?.calendar_progress == null ? null : Math.round(run.calendar_progress * 100))
// 2026-10-13 (T-213): runs started after this date store n_symbols (the writer never stores the raw list); older runs show n/a
export const symbolCount = (cfg) => { const v = cfg?.n_symbols ?? cfg?.symbols; return v == null ? 'n/a' : String(Array.isArray(v) ? v.length : v) }
